/* eslint-disable react/prop-types */
import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleClose = this.handleClose.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Erro capturado:', error, errorInfo);
  }

  handleClose() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    return (
      <>
        {this.props.children}
        {this.state.hasError && (
          <div className="error-popup">
            <div className="error-popup-content">
              <h2>Algo deu errado</h2>
              <pre>{this.state.error?.toString()}</pre>
              <button onClick={this.handleClose}>Fechar</button>
            </div>
          </div>
        )}
      </>
    );
  }
}
